import type { CSSProperties } from "react";

const controlStyle: CSSProperties = {
  padding: "8px 10px",
  border: "1px solid var(--color-border)",
  borderRadius: 6,
  background: "var(--color-bg)",
  color: "var(--color-text)",
};

export const styles: Record<string, CSSProperties> = {
  form: { display: "grid", gap: 14, maxWidth: 760 },
  row: { display: "grid", gap: 6 },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: "var(--color-text-secondary)",
  },
  input: controlStyle,
  textarea: {
    ...controlStyle,
    resize: "vertical",
  },
  textareaMono: {
    ...controlStyle,
    fontFamily: "var(--font-mono)",
    resize: "vertical",
  },
  button: {
    width: "fit-content",
    padding: "8px 16px",
    borderRadius: 6,
    border: "1px solid var(--color-primary)",
    background: "var(--color-primary)",
    color: "#fff",
  },
  error: { color: "var(--color-danger)", fontSize: 13, margin: 0 },
  success: { color: "var(--color-success)", fontSize: 13, margin: 0 },
};
